import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { initializeApp, getApps } from "firebase/app";
import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import "moment/locale/fr";

if (!getApps().length) {
  initializeApp(environment.firebase);
}

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => defineCustomElements(window))
  .catch((err) => console.error(err));
